import './App.css';
import Server from './Servers/Server';

function App() {
  return (
    <div className="App">
      <header>
          <img src="/logo.png"></img>
          <h1>Valorian at War</h1>
          <h2>Server-Status</h2>
      </header>
      <Server/>
    </div>
  );
}

export default App;
